import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from './AuthContext';
import { OrgUtil } from '@/data/OrgUtil';

const RequireAdmin = ({ children }: { children: ReactNode }) => {
    const { user } = useAuthContext();
    if (!user) return <Navigate to='/login' replace />;
    if (!OrgUtil.isRoleAdmin(user.data.role) && !OrgUtil.isRoleRoot(user.data.role)) {
        return <Navigate to='/organization' replace />;
    }
    return children;
};

export default RequireAdmin;
